import { Pipe } from '@angular/core';
var TailPipe = (function () {
    function TailPipe() {
    }
    TailPipe.prototype.transform = function (input, num) {
        if (num === void 0) { num = 0; }
        return Array.isArray(input) ? input.slice(num) : input;
    };
    return TailPipe;
}());
export { TailPipe };
TailPipe.decorators = [
    { type: Pipe, args: [{ name: 'tail' },] },
];
/** @nocollapse */
TailPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=tail.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/tail.js
// module id = 212
// module chunks = 4